import React, { useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FileUploader } from "react-drag-drop-files";
import { Link } from "react-router-dom";
import {
  cancellationsRefunds,
  memberGuestSeatsData
} from "../../assets/json/helpCenterData";
import FilterFaqs from "../../components/HelpCenter/FilterFaqs";

const fileTypes = ["JPEG", "PNG", "GIF", "JPG"];

const Billing = () => {
  const editorRef = useRef(null);
  const [file, setFile] = useState(null);
  const topicRequestRef = useRef(null);
  const [dropDownValue, setDropDownValue] = useState(null);

  // Function to handle the change in the select element
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setDropDownValue(selectedValue);
    console.log(`Selected value: ${selectedValue}`);
  };

  const handleChange = (file) => {
    setFile(file);
  };

  const handleFormatting = (command) => {
    document.execCommand(command, false, null);
  };

  return (
    <>
      <div className="container billing">
        <div className="row">
          <div className="col-12">
            <Form className="form">
              <Row>
                <Col xl={6} className="mb-3">
                  <Form.Label>Choose your issue below</Form.Label>
                  <Form.Select
                    defaultValue="Billing"
                    disabled
                    className="default-select-option"
                  >
                    <option>Billing</option>
                  </Form.Select>
                </Col>
                <Col xl={6} className="mb-3">
                  <Form.Label>Topic of Request *</Form.Label>
                  <Form.Select
                    defaultValue="-"
                    ref={topicRequestRef}
                    onChange={handleSelectChange} // Attach the event handler
                  >
                    <option>-</option>
                    <option value={"cancellationsRefunds"}>
                      Cancellations & Refunds
                    </option>
                    <option value={"memberGuestSeats"}>
                      Member & Guest seats
                    </option>
                    <option value={"PaymentsCharges"}>
                      Payments & Charges
                    </option>
                    <option value={"PlanChangesTrials"}>
                      Plan Changes & trials
                    </option>
                    <option value={"PricingDiscounts"}>
                      Pricing & Discounts
                    </option>
                  </Form.Select>
                </Col>
                {dropDownValue === "cancellationsRefunds" ? (
                  <>
                    <Col xl={12}>
                      <h4 className="faq-title">Frequently Asked Questions</h4>
                      <FilterFaqs data={cancellationsRefunds} />
                    </Col>
                    <Col xl={12}>
                      <h4 className="faq-title">
                        Still need help? No problem, reach out to our Support
                        team below.
                      </h4>
                      <p className="accordion-help">
                        If requesting a refund, ensure you have reviewed our{" "}
                        <Link to={"#"}>Refund Policy</Link> and provide as much
                        detail as possible to help our team expedite your
                        request.
                      </p>
                    </Col>
                    <Col xl={6} className="mb-3">
                      <Form.Label>Workspace Name</Form.Label>
                      <Form.Control placeholder="Enter Name" />
                    </Col>
                    <Col xl={6} className="mb-3">
                      <Form.Label>Amount of Transaction</Form.Label>
                      <Form.Control placeholder="Enter Amount" />
                    </Col>
                    <Col xl={6} className="mb-3">
                      <Form.Label>Date of Transaction</Form.Label>
                      <Form.Control placeholder="Enter Date" />
                    </Col>
                    <Col xl={6} className="mb-3">
                      <Form.Label>Last Four Digits of Card</Form.Label>
                      <Form.Control placeholder="Enter Last Four Digits" />
                    </Col>
                    <Col xl={12} className="mb-3">
                      <Form.Label>Card Expiration Date</Form.Label>
                      <Form.Control placeholder="Enter Expiration Date" />
                    </Col>
                    <Col xl={12} className="mb-3">
                      <Form.Label>
                        Has it been more than 30 days since you started your
                        Smartoffice plan? *
                      </Form.Label>
                      <div>
                        <Form.Check
                          inline
                          label="Yes"
                          name="group1"
                          type={"radio"}
                          id={`inline-radio-1`}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="group1"
                          type={"radio"}
                          id={`inline-radio-2`}
                        />
                      </div>
                    </Col>
                  </>
                ) : (
                  ""
                )}
                {dropDownValue === "memberGuestSeats" ? (
                  <>
                    <Col xl={12}>
                      <h4 className="faq-title">Frequently Asked Questions</h4>
                      <FilterFaqs data={memberGuestSeatsData} />
                    </Col>
                    <Col xl={12}>
                      <h4 className="faq-title">
                        Still need help? No problem, reach out to our Support
                        team below.
                      </h4>
                    </Col>
                    <Col xl={12} className="mb-3">
                      <Form.Label>Workspace Name</Form.Label>
                      <Form.Control placeholder="Enter Name" />
                    </Col>
                  </>
                ) : (
                  ""
                )}
                <Col xl={6} className="mb-3">
                  <Form.Label>Your email address *</Form.Label>
                  <Form.Control placeholder="Enter email" type="email" />
                </Col>
                <Col xl={6} className="mb-3">
                  <Form.Label>Subject *</Form.Label>
                  <Form.Control placeholder="Enter subject" />
                </Col>
                <Col xl={12} className="mb-3">
                  <Form.Label>Workspace Name</Form.Label>
                  <Form.Control placeholder="Enter Workspace Name" />
                </Col>
                <Col xl={12} className="mb-3">
                  <Form.Group className="mb-0" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Description</Form.Label>
                    <Form.Control as="textarea" rows={3} />
                  </Form.Group>
                  <Form.Label>
                    Please enter the details of your request. A member of our
                    support staff will respond as soon as possible.
                  </Form.Label>
                </Col>
                <Col xl={12} className="mb-3">
                  <Form.Label>Attachments</Form.Label>
                  <FileUploader
                    classes="file-uploading"
                    multiple={true}
                    handleChange={handleChange}
                    name="file"
                    types={fileTypes}
                    label={"Add file or drop files here"}
                    hoverTitle={"Drop here"}
                  />
                  <p className="upload-status">
                    {file
                      ? `File name: ${file[0].name}`
                      : "no files uploaded yet"}
                  </p>
                </Col>
                <Col xl={12}>
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Billing;
